import {
  tenantApplicationGet,
  tenantApplicationList,
  useTenantApplicationGet,
  useTenantApplicationGetSuspense,
  useTenantApplicationList,
  useTenantApplicationListSuspense,
} from "@/api/generated/endpoints/api"

// API hooks and functions
export const tenantApplicationApi = {
  // Query hooks
  useTenantApplicationList,
  useTenantApplicationListSuspense,
  useTenantApplicationGet,
  useTenantApplicationGetSuspense,

  // Direct API functions
  tenantApplicationList,
  tenantApplicationGet,
}

export * as TenantApplicationModels from "./models"
